import React from 'react';

import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './shared.module.sass';
import { toggleValue } from '../utils/array';

export const NO_SOURCE_VALUE = 'null';

interface NoSourceGroupProps {
  selectedSources: string[];
  onChangeSelectedSource: (next: string[]) => void;
}

export function NoSourceGroup({
  selectedSources,
  onChangeSelectedSource,
}: NoSourceGroupProps): React.JSX.Element {
  const { t } = useTranslation();

  const checked = selectedSources.includes(NO_SOURCE_VALUE);

  return (
    <div className={st.Group}>
      <div className={st.GroupHeader}>
        <Control.Checkbox
          checked={checked}
          className={st.Checkbox}
          label={t('sources.no source title')}
          onChangeValue={(next) => {
            onChangeSelectedSource(toggleValue(selectedSources, NO_SOURCE_VALUE, next));
            return true;
          }}
        />
      </div>
    </div>
  );
}
